import LOCAL_STORAGE_KEY from "./constant";

// Forge is on by default; the flag only needs to be set to "false" to opt out.
const isForgeEnabled = () => localStorage.getItem(LOCAL_STORAGE_KEY.FORGE_ENABLED) !== "false";

export default isForgeEnabled;
